/**
 * @generated SignedSource<<cd657bcd255dd39490fb1d68805bbb04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SelectCurrencies_Query$variables = Record<PropertyKey, never>;
export type SelectCurrencies_Query$data = {
  readonly currencies: ReadonlyArray<{
    readonly code: string | null | undefined;
  }> | null | undefined;
};
export type SelectCurrencies_Query = {
  response: SelectCurrencies_Query$data;
  variables: SelectCurrencies_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "allowContracts",
    "value": true
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectCurrencies_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "Currency",
        "kind": "LinkedField",
        "name": "currencies",
        "plural": true,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "currencies(allowContracts:true)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectCurrencies_Query",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "Currency",
        "kind": "LinkedField",
        "name": "currencies",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "currencies(allowContracts:true)"
      }
    ]
  },
  "params": {
    "cacheID": "991a03905c9ab3cda4e8929ccc3ab237",
    "id": null,
    "metadata": {},
    "name": "SelectCurrencies_Query",
    "operationKind": "query",
    "text": "query SelectCurrencies_Query {\n  currencies(allowContracts: true) {\n    code\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d40d2ca1e2221ac46fbb00e75841b6c4";

export default node;
